/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ApiProblemTypes = {
    DateiTypNichtErlaubt: 'DateiTypNichtErlaubt',
    BenutzerNichtGefunden: 'BenutzerNichtGefunden',
    BenutzerNichtAktiviert: 'BenutzerNichtAktiviert',
    MandantIdFehlt: 'MandantIdFehlt',
    KeinMandantAdmin: 'KeinMandantAdmin',
    KeinBenutzerZugriff: 'KeinBenutzerZugriff',
    KeinMandantAdminOderTechAdmin: 'KeinMandantAdminOderTechAdmin',
    KeineLizenz: 'KeineLizenz',
    KeineLizenzOption: 'KeineLizenzOption',
    ModulNichtAktiv: 'ModulNichtAktiv',
    NichtGefunden: 'NichtGefunden',
    KeinInhalt: 'KeinInhalt',
    BenutzerLizenz: 'BenutzerLizenz'
} as const;
export type ApiProblemTypes = typeof ApiProblemTypes[keyof typeof ApiProblemTypes];

